export const PRODUCT_NAME = 'AI-ARCS';
export const SUPPORT_EMAIL = 'support@triatechsol.com';
